// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__15iZP","bigColWidth":"Table_bigColWidth__dtJWa","biggerColWidth":"Table_biggerColWidth__3HN_h","row":"Table_row__OXSVO","col":"Table_col___K-aM"};